<template>
  <CCard class="resumeDetail bg-gray-200 py-5" v-if="infos.length">
    <CRow>
      <CCol sm="3" class="d-flex justify-content-center align-items-center text-gray-500">
        <CIcon name="userBgFull" :height="100" viewBox="0 0 32 32" />
      </CCol>
      <CCol sm="6" class="p-0 ">
        <CCardBody class="p-0">
          <h3 class="mb-3 font-weight-normal">{{ title }}</h3>
          <div class="text-gray-700">
            <p style="font-size:20px">
              {{ $t('audience.detailContact.resumeDetail.text1') }}
              {{ audienceCreatedFrom }}
              {{ opt(createdDatetime) }}
            </p>
            <p class="font-base">
              {{ $t('audience.detailContact.resumeDetail.update') }}
              : {{ opt(UpdatedDatetime) }}
            </p>
            <div class="d-flex align-items-center">
              <p class="my-0 mr-4 d-flex align-items-center">
                {{ $t('audience.detailContact.resumeDetail.text.status') }}:
                <CSpinner class="mx-1" size="sm" v-if="loading" color="primary" />
                <b v-else class="mx-2" :class="statusValue == 'ACTIVE' ? 'text-success' : 'text-danger'">{{ statusValue }}</b>
              </p>
              <v-select
                style="min-width: 160px"
                :get-option-label="getLabel"
                v-model="selected"
                class="resumeDetail__select m-0 no-close px-2"
                :options="options"
                @input="sendState"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <i class="fas fa-chevron-down font-xs  font-weight-normal"></i>
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </CCardBody>
        <CCol sm="12">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import { dateTimeFormatString } from '@/utils/dateUtil'
import services from '@/services.js'
import vSelect from 'vue-select'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'ResumeDetail',
  components: {
    vSelect,
    MenssageAlert,
  },
  data() {
    return {
      loading: false,
      messages: [],
      infos: [],
      recipient: [],
      selected: {},
      statusValue: '',
      createdDatetime: '',
      UpdatedDatetime: '',
      createdFrom: '',
      options: [
        { Key: 0, Value: 'ACTIVE' },
        { Key: 1, Value: 'INACTIVE' },
      ],
    }
  },
  computed: {
    title() {
      return this.infos[0].fieldValue || ''
    },

    resumeDetailRecepient() {
      if (this.$store.state.audience.recipient && this.$store.state.audience.schemaAudience) {
        return JSON.parse(JSON.stringify(this.$store.getters['audience/contactInfoRecepient'](false)))
      }
      return []
    },

    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },

    audienceCreatedFrom() {
      const translationKeyMap = {
        0: 'file-import',
        1: 'manual-import',
        2: 'ftp-import',
        3: 'api-import'
      };

      const translationKey = translationKeyMap[this.createdFrom.Key] || 'file-import'; 

      return this.$t(`audience.detailContact.resumeDetail.${translationKey}`)
    }
  },
  methods: {
    opt(data) {
      const dateCurrent = data
      return dateTimeFormatString(dateCurrent)
    },

    getLabel(option) {
      return `${option.Value}`
    },

    sendState() {
      this.messages = []
      this.loading = true

      services
        .recipientStatus(this.$route.params.organizationId, this.$route.params.id, '"' + this.selected.Value + '"')
        .then(({ data }) => {
          this.messages.push({
            status: 'success',
            text: data.message || 'infomation saved',
          })

          this.statusValue = this.selected.Value
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message || response.data.title,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    resumeDetailRecepient(newValues) {
      this.infos = newValues
    },
    getterRecipient(newValues) {
      this.recipient = newValues
      this.selected = newValues._MetaData.Status || ''
      this.statusValue = newValues._MetaData.Status.Value || ''
      this.createdDatetime = newValues._MetaData.CreatedDatetime || ''
      this.UpdatedDatetime = newValues._MetaData.UpdatedDatetime || ''
      this.createdFrom = newValues._MetaData.CreatedFrom || ''
    },
  },
}
</script>

<style lang="scss" scope>
.resumeDetail {
  background: none;
  border: none;
  box-shadow: none !important;

  &__select {
    font-size: $font-size-base;
    text-transform: lowercase;
    color: $gray-700;

    .vs__selected {
      color: $gray-700;
    }
  }
}
</style>
